// Copyright 2026 Sorama B.V.

import { SelectableRange } from "services/FrequencySelection/FrequencySelectionService";
import { CriticalBandUnit } from "units/Unit";

// Each band is stored in the service edge-to-edge (center ± 0.5), so offset by ±0.5 to recover the integer center.
export function hzRangesToCriticalBandRanges(
    hzRanges: SelectableRange[],
    bandUnit: CriticalBandUnit
): SelectableRange[] {
    return hzRanges.map((range) => {
        const fromBand = bandUnit.convertHzToBand(range.from) + 0.5;
        const toBand = bandUnit.convertHzToBand(range.to) - 0.5;
        const bandRange = new SelectableRange(fromBand, toBand);
        bandRange.isSelected = range.isSelected;
        return bandRange;
    });
}

// Inverse of hzRangesToCriticalBandRanges: expand integer-center bands outward by ±0.5 to get edge-to-edge Hz spans.
export function criticalBandRangesToHzRanges(
    bandRanges: SelectableRange[],
    bandUnit: CriticalBandUnit
): SelectableRange[] {
    return bandRanges.map((range) => {
        const fromHz = bandUnit.convertBandToHz(range.from - 0.5);
        const toHz = bandUnit.convertBandToHz(range.to + 0.5);
        const hzRange = new SelectableRange(fromHz, toHz);
        hzRange.isSelected = range.isSelected;
        return hzRange;
    });
}
